import { Reaction } from '@/types/models';

export const getBioEntitiesIdsFromReaction = (reaction: Reaction): string[] => {
  const { products, reactants, modifiers } = reaction;
  const productsIds = products.map(p => ('aliasId' in p ? p.aliasId : p.element));
  const reactantsIds = reactants.map(r => ('aliasId' in r ? r.aliasId : r.element));
  const modifiersIds = modifiers.map(m => ('aliasId' in m ? m.aliasId : m.element));
  return [...productsIds, ...reactantsIds, ...modifiersIds].map(identifier => String(identifier));
};
